import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
import { GroupGallectionType } from './types';

// Dynamic redux
export const reduxModuleLoaded = createAction(
  `${reduxKey}.REDUX_READY`,
  () => ({})
);

export const fetchGroupGallections = createAction(
  `${reduxKey}.FETCH_GROUP_GALLECTIONS`,
  (groupid: number, type: GroupGallectionType) => ({ groupid, type })
);

export const fetchGroupGallectionsSuccess = createAction(
  `${reduxKey}.FETCH_GROUP_GALLECTIONS.SUCCESS`,
  (groupid: number, type: GroupGallectionType, gallectionids: number[]) => ({
    groupid,
    type,
    gallectionids,
  })
);

export const fetchGroupGallectionsError = createAction(
  `${reduxKey}.FETCH_GROUP_GALLECTIONS.ERROR`,
  message => ({ message })
);
